// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Anchors__Wrapper_3nxlf","Title":"Anchors__Title_1_hCX","List":"Anchors__List_35vMD","Anchor":"Anchors__Anchor_1LDET"};